module.exports = __webpack_public_path__ + "static/img/case4.3d71802.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ServiceCase/case4.png
// module id = mMwY
// module chunks = 1